import { Box, Button, styled } from '@mui/material';
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import FormInput from 'UI/Form/FormInput';
import { useAddCultureMutation } from '@Store/api/translationsSlice';
import resolver, { IAddCultureForm } from './AddCultureForm.validation';

const FormContainer = styled(Box)`
  display: flex;
  flex-direction: column;

  & .MuiFormHelperText-root {
    color: red !important;
  }
`;

interface IProps {
  handleClose: () => void;
}

export function AddCultureForm({ handleClose }: IProps) {
  const [addCulture] = useAddCultureMutation();

  const methods = useForm<IAddCultureForm>({
    defaultValues: {
      cultureCode: '',
      displayName: '',
    },
    resolver,
  });
  const {
    control,
    formState,
    register,
    unregister,
    watch,
    getValues,
    getFieldState,
    setError,
    clearErrors,
    setValue,
    trigger,
    resetField,
    reset,
    handleSubmit,
    setFocus,
  } = methods;

  const handleFormSubmit: SubmitHandler<IAddCultureForm> = async (data) => {
    try {
      await addCulture(data).unwrap();
      toast.success('Culture added');
      handleClose();
    } catch (err: any) {
      const message =
        err?.data?.message || err?.message || 'Something went wrong...';
      toast.error(message);
    }
  };

  return (
    <FormProvider
      clearErrors={clearErrors}
      control={control}
      formState={formState}
      getFieldState={getFieldState}
      getValues={getValues}
      handleSubmit={handleSubmit}
      register={register}
      reset={reset}
      resetField={resetField}
      setError={setError}
      setFocus={setFocus}
      setValue={setValue}
      trigger={trigger}
      unregister={unregister}
      watch={watch}
    >
      <FormContainer component='form' onSubmit={handleSubmit(handleFormSubmit)}>
        <div style={{ marginTop: 0 }}>
          <FormInput
            label='Culture Code (e.g. en-GB, fr-FR)'
            name='cultureCode'
            type='text'
          />
        </div>

        <div style={{ marginTop: 30 }}>
          <FormInput
            label='Language Name (e.g. English (UK))'
            name='displayName'
            type='text'
          />
        </div>

        <Button
          fullWidth
          sx={{ mt: '30px', textTransform: 'capitalize', fontSize: 16 }}
          type='submit'
          variant='contained'
        >
          Add Culture
        </Button>
      </FormContainer>
    </FormProvider>
  );
}
